



























































































import Vue from 'vue'
import Component from "vue-class-component"
import { customer } from '@/store'
import { Prop } from "vue-property-decorator"
import { getFullImageUrl } from '@/utils/functions'
import { getOrder, getOrderPayment, unlockOrder } from '@/utils/customerApi'
import Order, { emptyOrder } from '@/models/order'
import { shopPath } from '@/utils/shop'
import { track } from '@/utils/track'
import OrderProductsTable from '@/components/orders/OrderProductsTable.vue'
import { deliveryServiceFormatted } from '@/utils/constants'
var numeral = require('numeral');

// Только показ готового заказа. Форма оформления — OrderForm.vue: здесь с
// первой версии лежала её копия, и правки (аналитика, адрес на домене
// магазина) уходили в неё и молча не работали.
@Component({
  components: {
    OrderProductsTable
  }
})
export default class OrderPage extends Vue {
  shopPath = shopPath
  @Prop() publicUrl!: string
  @Prop() orderId!: number
  loading = true
  order: Order = emptyOrder()
  paymentLink = ''

  unlockPhone = ''
  unlockError = ''
  unlocking = false

  getFullImageUrl = getFullImageUrl
  deliveryServiceFormatted = deliveryServiceFormatted

  get retailerPage() {
    return customer.retailerPage
  }

  get trackingLink() {
    if (this.order.deliveryService == 'nova_poshta') {
      return `https://novaposhta.ua/tracking/?cargo_number=${this.order.ttn}`
    } else if (this.order.deliveryService == 'rozetka_delivery') {
      // Публичного трекинга по номеру у Rozetka Delivery нет — статус
      // покупателю сообщает магазин
      return ''
    } else {
      return `https://track.ukrposhta.ua/tracking_UA.html?barcode=${this.order.ttn}`
    }
  }

  get warehouseLabel() {
    if (this.order.deliveryService == 'rozetka_delivery') {
      return this.$t('Отделение')
    }
    if (this.order.homeDelivery && this.order.deliveryService == 'ukr_poshta') {
      return this.$t('Отделение почты (ближайшее к адресу)')
    } else {
      return this.$t('Отделение почты')
    }
  }

  // Ключ заказа из адреса: только с ним сервер отдаёт заказ целиком
  get token() {
    return this.$route.query.token as string
  }

  translate(str: string) {
    return this.$t(str) as string
  }

  ttnCopiedNotify() {
    this.$notify({
      group: 'br',
      text: this.translate('ТТН скопирована!'),
      type: 'success'
    });
  }

  formatTtn(ttn: string) {
    // Номер накладной Rozetka Delivery на группы по 4 не делится
    if (this.order.deliveryService == 'rozetka_delivery') {
      return ttn
    }
    let reversed = ttn.split("").reverse().join("")
    let exploded = reversed.match(/.{1,4}/g);
    exploded = (exploded as any).join(' ')
    exploded = (exploded as any).split("").reverse().join("")
    return exploded
  }

  formatId(id: Number) {
    return numeral(id).format('00000')
  }

  async getOrder() {
    try {
      var order = await getOrder(this.publicUrl, this.orderId, this.token)
      if (order.id)
        this.order = order
    } catch {
      console.log("Order not found")
    }
  }

  // Покупатель вернулся с кассы: уведомление от неё приходит отдельным
  // запросом к серверу и может задержаться, поэтому спрашиваем сами.
  async checkPayment() {
    if (!this.order.draft) return
    try {
      var payment = await getOrderPayment(this.publicUrl, this.orderId, this.token)
    } catch {
      return
    }
    this.paymentLink = payment.paymentLink || ''
    if (payment.paid) {
      await this.getOrder()
      this.paymentLink = ''
    }
  }

  // Ссылка без ключа — выданная до него или потерянная: покупатель открывает
  // заказ номером телефона, а ключ ложится в адрес, чтобы дальше хватало ссылки
  async unlock() {
    this.unlocking = true
    this.unlockError = ''
    try {
      var token = await unlockOrder(this.publicUrl, this.orderId, this.unlockPhone)
    } catch (error) {
      var response = (error as any).response
      this.unlockError = this.translate(response && response.status == 429
        ? 'Слишком много попыток. Попробуйте через час или свяжитесь с магазином.'
        : 'Номер не совпадает с номером в заказе. Проверьте его или свяжитесь с магазином.')
      this.unlocking = false
      return
    }
    await this.$router.replace({ query: { ...this.$route.query, token } })
    await this.getOrder()
    await this.checkPayment()
    this.unlocking = false
  }

  // Покупка засчитывается один раз, в браузере, где заказ оформили, и только
  // когда он подтверждён: при оплате картой — после ответа кассы
  trackPurchase() {
    var pending = customer.pendingPurchase
    if (pending && pending.orderId == this.order.id && !this.order.draft) {
      track('purchase', pending.payload)
      customer.setPendingPurchase(null)
    }
  }

  async mounted() {
    this.loading = true
    await customer.getRetailerPage(this.publicUrl)
    await this.getOrder()
    await this.checkPayment()
    this.trackPurchase()
    this.loading = false
  }
}
